/**
 * Products query
 */

import gql from 'graphql-tag'

// TODO: delete alias
export const productsQuery = gql`
  query GetProducts(
    $gender: String
    $category: String
    $sport: String
    $sportGroup: String
    $onlyCustom: Boolean
    $onlyEvo: Boolean
    $limit: Int = 10
  ) {
    products(
      gender: $gender
      category: $category
      sport: $sport
      sportGroup: $sportGroup
      limit: $limit
      order: "id"
      onlyCustom: $onlyCustom
      onlyEvo: $onlyEvo
      fromTop: true
    ) {
      fullCount
      products {
        id
        code
        yotpoId: yotpo_id
        name
        type: name
        description: short_description
        shortDescription: short_description
        customizable: design_center
        comingSoon: coming_soon
        retailMen: men_retail
        retailWomen: women_retail
        category_id
        genders {
          id
          name: gender
        }
        priceRange {
          quantity
          price
          abbreviation
          shortName: short_name
        }
        images: pictures {
          front: front_image
          genderId: gender_id
          color_id
          thumbnail
        }
        colors {
          id
          name
          image
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductHorizontalList/data.ts